import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import globals from '@/utils/globals';
import { computed, ref, Ref, nextTick } from 'vue';

export default class EmailInput {
	public input: Ref<HTMLInputElement | null> = ref(null);
	public hasFocus = ref(false);

	public constructor(public store: IIncentiveV2Store) {}

	public email = computed((): string | null => {
		return this.store.getters.email();
	});

	public showEmailError = computed((): boolean => {
		return this.store.getters.showEmailError();
	});

	public setFocusOnInput(): void {
		const inputElement = this.input.value;
		if (typeof inputElement === 'undefined') {
			return;
		}
		inputElement?.focus();
	}

	public setFocused(hasFocus: boolean): void {
		this.hasFocus.value = hasFocus;
	}

	public saveEmail(isBlurEvent: boolean, event:Event): void {
		void isBlurEvent;
		this.setFocused(false);
		this.store.actions.saveEmail((event.target as HTMLInputElement).value);
	}

	updated(): void {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		nextTick(() => {
			globals.eventBus.emit('authPopupCalculatePadding');
		});
	}
}
